import { N, round, ceil } from './helpers.mjs';

export const PAINTERS = [
  // ====================== PAINTERS ======================
  {
    slug: 'paint-coverage',
    trade: 'painters',
    name: 'Paint Coverage',
    blurb: 'Typical emulsion ~12 m²/L. Add coats.',
    inputs: [
      { key: 'area', label: 'Area to paint', unit: 'm²', placeholder: '30' },
      { key: 'coats', label: 'Number of coats', unit: '', placeholder: '2', default: 2 },
      { key: 'coverage', label: 'Coverage per litre', unit: 'm²/L', placeholder: '12', default: 12 },
    ],
    compute: (v) => {
      const litres = (N(v.area) * N(v.coats)) / (N(v.coverage) || 12);
      return [
        { label: 'Paint needed', value: round(litres, 2), unit: 'litres' },
        { label: '2.5L tubs', value: ceil(litres / 2.5), unit: 'tubs' },
        { label: '5L tubs', value: ceil(litres / 5), unit: 'tubs' },
      ];
    },
  },
  {
    slug: 'wallpaper-rolls',
    trade: 'painters',
    name: 'Wallpaper Rolls',
    blurb: 'Standard roll 10.05m × 0.53m.',
    inputs: [
      { key: 'perimeter', label: 'Room perimeter', unit: 'm', placeholder: '14' },
      { key: 'height', label: 'Wall height', unit: 'm', placeholder: '2.4' },
      { key: 'pattern', label: 'Pattern repeat', unit: 'cm', placeholder: '0', default: 0 },
    ],
    compute: (v) => {
      const dropLen = N(v.height) + N(v.pattern) / 100;
      const dropsPerRoll = Math.floor(10.05 / Math.max(dropLen, 0.01));
      const totalDrops = ceil(N(v.perimeter) / 0.53);
      const rolls = dropsPerRoll > 0 ? ceil(totalDrops / dropsPerRoll) : 0;
      return [
        { label: 'Drops needed', value: totalDrops, unit: 'drops' },
        { label: 'Drops per roll', value: dropsPerRoll, unit: '' },
        { label: 'Rolls required', value: rolls, unit: 'rolls' },
      ];
    },
  },

];
